import { StateTree } from ".";

export class BaseState {
	protected ref: StateTree;

	constructor(ref: StateTree) {
		this.ref = ref;
	}
}
